























































































































import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import Activity from '@/components/activity/Activity.vue';
import ActivityStatus from '@/components/activity/ActivityStatusText.vue';
import RoutePaths from '@/router/route_paths';
import axios, { AxiosError, AxiosResponse } from 'axios';
import xml2js from 'xml2js';
import { Phrase, PhraseResponse } from '@/store/types';

export default Vue.extend({
  components: {
    activity: Activity,
    'activity-status': ActivityStatus,
  },
  data() {
    return {
      flashcards: new Array<Phrase>(),
      flashcardsIndex: 0,
      activityVisible: false,
      hidePhraseActivity: true,
      originalHideNative: false,
      drillCompleted: false,
    };
  },
  computed: {
    drillPhrase(): Phrase | null {
      if (this.flashcards.length > 0) {
        return this.flashcards[0];
      }
      return null;
    },
  },
  async mounted() {
    this.hidePhraseActivity = true;
    this.originalHideNative = this.$store.state.hideNative;
    this.hideNative();
    await this.loadFlashcards();
    this.activityVisible = true;
  },
  methods: {
    async activityReady() {
      this.hideNative();
      (this.$refs.activityStatus as any).updateText('');
      this.hidePhraseActivity = true;
      this.activityVisible = true;
      if (this.$store.getters.isSignLang) {
        (this.$refs.activity as any).playActivityPlayerOnly();
      }
    },
    async loadFlashcards() {
      const idLangIForRequest = this.$store.state.level.obj_id === '6'
        ? BbTools.getILangAsLLang(this.$store.state.langI!.id) : this.$store.state.langI!.id;
      const params = BbTools.getDefaultParams();
      params.append('cmd', 'bbcard');
      params.append('fbtoken', this.$store.state.firebaseToken);
      params.append('v2', 'true');
      const url = `${this.$store.getters.URL_PHRASES}?num_pars[]=${this.$store.state.level.obj_id}&num_pars[]=${this.$store.state.unit.unit}&num_pars[]=${this.$store.state.lesson.id}&num_pars[]=${idLangIForRequest}&num_pars[]=${this.$store.state.langL!.id}`;
      return axios.post(url, params, BbTools.bbHeaders)
        .then((response: AxiosResponse) => {
          try {
            xml2js.parseString(response.data, (error: Error, result: any) => {
              if (result && result.Page) {
                const phrases = new Array<Phrase>();
                if (result.Page.Card) {
                  result.Page.Card.forEach((phraseResponse: PhraseResponse) => {
                    const phrase = phraseResponse.$ as Phrase;
                    phrase.word = LearningTools.formatPhrase(phrase.word);
                    phrase.audio += BbTools.APP_POSTFIX;
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    phrase.native_word = LearningTools.formatPhrase(phrase.native_word);
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    phrase.audio_native = BbTools.replaceAll(phrase.audio,
                      `/${this.$store.state.langL.id}/`, `/${this.$store.state.langI.id}/`);
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    phrase.word_image += BbTools.APP_POSTFIX;
                    phrase.bbImage = `${this.$store.getters.ipLearn}/files/images/pro/${phrase.id}.jpg${BbTools.APP_POSTFIX}`;
                    phrases.push(phrase);
                  });
                }
                this.flashcards = phrases;
                if (phrases.length === 0) {
                  this.$emit('completed');
                }
              } else {
                this.$store.commit('setAlertMessage', {
                  text: 'Flashcards error #1',
                  error,
                });
              }
            });
          } catch (error) {
            this.$store.commit('setAlertMessage', {
              text: 'Flashcards error #2',
              error,
            });
          }
        })
        .catch((error: AxiosError) => {
          this.$store.commit('setAlertMessage', {
            text: 'Flashcards error #3',
            error,
          });
        });
    },
    hideNative() {
      if (!this.$store.state.hideNative) {
        this.$store.commit('hideNative');
      }
    },
    showNative() {
      if (this.$store.state.hideNative) {
        this.$store.commit('hideNative');
      }
    },
    onReveal() {
      this.hidePhraseActivity = false;
      this.showNative();
      const statusText = `${this.$store.state.tr.DidYouKnow} ${this.$store.state.tr.ClickAButton}`;
      (this.$refs.activityStatus as any).updateText(statusText);
      (this.$refs.activity as any).startPlaying();
    },
    async onFace(face: number) {
      (this.$refs.activityStatus as any).updateText('');
      this.activityVisible = false;
      this.hidePhraseActivity = true;
      (this.$refs.activity as any).stopActivity();
      await BbTools.sleepCancelable(LearningTools.TO_HIDE_ACTIVITY, this.$store);
      (this.$refs.activity as any).movieFrame = '';
      if (face === 1) {
        this.handleFlashcard(5);
      } else if (face === 2) {
        this.handleFlashcard(10);
      } else if (face === 3) {
        this.removeFlashcard(3);
        this.handleFlashcard(-1);
      } else if (face === 4) {
        this.removeFlashcard(4);
        this.handleFlashcard(-1);
      }
      (this.$refs.activity as any).setActivityReady(null, true);
      if (this.flashcards.length === 0) {
        this.$emit('completed');
        LearningTools.loadLessons(this.$store);
      }
    },
    handleFlashcard(position: number) {
      const flashcard = this.flashcards.shift();
      if (flashcard && position !== -1) {
        if (this.flashcards.length < position) {
          this.flashcards.push(flashcard);
        } else {
          this.flashcards.splice(position, 0, flashcard);
        }
      }
    },
    removeFlashcard(severity: number) {
      const params = BbTools.getDefaultParams();
      params.append('user_id', this.$store.state.user.uid);
      params.append('lLangId', this.$store.state.langL!.id);
      params.append('image', this.flashcards[0].id);
      params.append('severity', severity.toString());
      return axios.post(this.$store.getters.URL_FLASHCARDS_REMOVE, params, BbTools.bbHeaders)
        .catch((error) => {
          BbTools.handleError(error, 'Flashcards error #4', this.$store);
        });
    },
  },
  beforeDestroy() {
    if (this.$store.state.sleepPromise) {
      this.$store.state.sleepPromise.cancel();
    }
    if (this.originalHideNative !== this.$store.state.hideNative) {
      this.$store.commit('hideNative');
    }
  },
});
